<!--This component (step 3) to choose the available tables-->
<template>
	<v-card-text>
		<v-row>
			<!--Start Available Tables-->
			<v-col cols="12" sm="12" md="12" lg="12">
				<v-card elevation="0">
					<div class="mb-16 headline font-weight-bold headline1--text">
						{{ $t("generic.lang_tables_title") }}
					</div>

					<!--loader-->
					<div class="text-center">
						<v-progress-circular indeterminate v-if="loading" color="primary" size="128" />
					</div>

					<v-alert :type="alertType" :text="alertType == 'error' ? true : false" outlined icon="mdi-alert">
						{{
							!errorMsg
								? this.$t("generic.lang_tables_wrong_title")
								: this.$t("generic.lang_tables_error_title") + " " + this.numberPersons
						}}
					</v-alert>

					<div v-if="Array.isArray(this.rooms) && this.rooms.length">
						<v-tabs
							v-model="roomSelected"
							background-color="secondary"
							active-class="primary white--text"
							hide-slider
							grow
							show-arrows
							center-active
							centered
						>
							<v-tab v-for="room in rooms" :key="room.id">
								{{ room.name }}
							</v-tab>
						</v-tabs>

						<v-tabs-items v-model="roomSelected" class="pt-6">
							<v-tab-item v-for="room in rooms" :key="room.id" disabled>
								<v-item-group v-model="selectedTables" multiple active-class="primary" :max="maxTables">
									<v-container
										ref="containerRef"
										class="rel scroll-x"
										style="height: 550px;"
										@scroll="handleScroll"
									>
										<div class="room-floor" :style="roomStyle(room)">
											<div
												v-for="roomTable in room.tables"
												:key="roomTable.uuid"
												align="center"
												justify="center"
											>
												<v-item v-slot="{ active, toggle }" :value="roomTable.uuid">
													<v-card
														:color="active ? 'primary' : 'secondary'"
														class="rel2 align-center"
														elevation="0"
														@click="toggle"
														:style="tableStyle(roomTable)"
													>
														<div class="custom-container">
															<div class="tableName">{{ roomTable.name }}</div>
															<v-chip class="custom-chip" color="grey lighten-4">
																{{ roomTable.maxPersons }}
																{{ $t("generic.lang_persons") }}
															</v-chip>
														</div>
													</v-card>
												</v-item>
											</div>
										</div>
									</v-container>
									<!-- Don't worry ! This is just for the scroll Indicator for mobile devices :) -->
									<v-row v-show="isRowVisible">
										<v-col :style="{ justifyContent: 'flex-end', display: 'flex', paddingRight: '0' }"
											><div class="arrow-scroll inv">
												<div class="arrow"></div>
												<div class="arrow"></div>
												<div class="arrow"></div></div
										></v-col>
										<v-col :style="{ paddingLeft: '0' }"
											><div class="arrow-scroll">
												<div class="arrow"></div>
												<div class="arrow"></div>
												<div class="arrow"></div></div
										></v-col>
									</v-row>
									<!--END scroll indicator-->
								</v-item-group>
							</v-tab-item>
						</v-tabs-items>
					</div>

					<v-sheet v-else elevation="0" outlined height="200" class="d-flex justify-center align-center">
						<p>
							{{ $t("generic.lang_no_table_available") }}
						</p>
					</v-sheet>

					<!---->
				</v-card>
			</v-col>
			<!--End Available Tables-->
		</v-row>
	</v-card-text>
</template>

<script>
/**
 * import plugins
 */
import { createNamespacedHelpers } from "vuex";

export default {
	name: "Step3Component",

	data() {
		return {
			alertType: "warning",
			errorMsg: false,

			maxTables: 100,

			roomSelected: 0,

			sumMaxPersons: 0,
			stopAddTables: false,
			containerWidth: 0,
			containerHeight: 0,
			isRowVisible: window.innerWidth <= 839,
		};
	},

	computed: {
		cardLeft() {
			return this.containerWidth;
		},
		cardTop() {
			return this.containerHeight;
		},
		//map loader getters
		...createNamespacedHelpers("loader").mapGetters(["loading"]),
		...createNamespacedHelpers("tables").mapGetters(["rooms"]),
		...createNamespacedHelpers("reservationTypes").mapState(["numberPersons"]),

		selectedTables: {
			get() {
				return this.$store.state.tables.tables;
			},
			set(val) {
				this.$store.commit("tables/addTables", val);

				/*if (
          !this.stopAddTables ||
          (Array.isArray(this.selectedTables) &&
            this.selectedTables.length == 0)
        ) {
          this.$store.commit("tables/addTables", val);
        } else {
          this.selectedTables.forEach((selectedTable) => {
            if (val == selectedTable) {
              this.$store.commit("tables/deleteTables", val);
            }
            if (val == "") {
              this.$store.commit("tables/addTables", []);
            }
          });
        }*/
			},
		},
	},

	mounted() {
		this.containerWidth = this.$refs.containerRef?.clientWidth;
		this.containerHeight = this.$refs.containerRef?.clientHeight;
		this.checkAddTables();
	},
	watch: {
		selectedTables() {
			this.checkAddTables();
		},
	},

	methods: {
		handleScroll() {
			const scrollLeft = this.$refs.containerRef.scrollLeft;
			this.isRowVisible = scrollLeft === 0;
		},
		roomStyle(room) {
			return {
				backgroundImage: room.backgroundImage ? `url("${room.backgroundImage}")` : "none",
				backgroundColor: room.backgroundColor || "transparent",
			};
		},
		tableStyle(roomTable) {
			return {
				height: roomTable.height * 5 + "px",
				width: roomTable.width * 8 + "px",
				borderRadius: roomTable.type === "round" ? "30%" : "10%",
				top: roomTable.top * 5 + "px",
				left: roomTable.left * 8.4 + "px",
			};
		},
		checkAddTables() {
			this.sumMaxPersons = 0;
			var tableMaxPersons = 0;

			this.rooms.forEach((room) => {
				room.tables.forEach((roomTable) => {
					//
					this.selectedTables.forEach((selectedTable) => {
						if (roomTable.uuid == selectedTable) {
							tableMaxPersons = roomTable.maxPersons;

							this.sumMaxPersons = eval(this.sumMaxPersons + tableMaxPersons);
						}
					});
					//
				});
			});

			if (this.sumMaxPersons >= this.numberPersons) {
				this.stopAddTables = true;
				this.maxTables = this.selectedTables.length;
			} else {
				this.alertType = "warning";
				this.errorMsg = false;
			}
		},
		checkMaxPersons() {
			if (
				Array.isArray(this.selectedTables) &&
				this.selectedTables.length != 0 &&
				this.selectedTables != null
			) {
				this.sumMaxPersons = 0;
				var tableMaxPersons = 0;

				this.rooms.forEach((room) => {
					room.tables.forEach((roomTable) => {
						//
						this.selectedTables.forEach((selectedTable) => {
							if (roomTable.uuid == selectedTable) {
								tableMaxPersons = roomTable.maxPersons;

								this.sumMaxPersons = eval(this.sumMaxPersons + tableMaxPersons);
							}
						});
						//
					});
				});

				if (this.sumMaxPersons >= this.numberPersons) {
					this.alertType = "warning";
					this.errorMsg = false;
					return true;
				} else {
					document.body.scrollTop = 0; // For Safari
					document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera

					this.alertType = "error";
					this.errorMsg = true;

					return false;
				}
			} else {
				return true;
			}
		},
	},
};
</script>

<style scoped>
.custom-chip {
	height: 25px;
	font-size: 12px;
	position: absolute;
	left: 10%;
	right: 10%;
	bottom: 5%;
	display: flex;
	align-items: center;
	justify-content: center;
}
.custom-container {
	position: relative;
	width: 100%;
	height: 100%;
}
.arrow-scroll {
	position: relative;
	width: 50px;
	height: 50px;
	align-items: center;
	justify-content: center;
	opacity: 0.5;
}
.arrow-scroll.inv {
	transform: rotateY(180deg);
}
.arrow {
	border: solid orange;
	border-width: 0 5px 5px 0;
	display: inline-block;
	padding: 12px;
	position: absolute;
	top: 50%;
	left: 0;
	transform: translateY(-50%) rotate(-45deg);
}

.arrow:nth-child(2) {
	animation: arrow1 1.5s ease-in-out infinite;
}

.arrow:nth-child(3) {
	animation: arrow2 1.5s ease-in-out infinite;
}

@keyframes scroll {
	0% {
		right: 80%;
		opacity: 1;
	}
	100% {
		right: 20%;
		opacity: 0;
	}
}

@keyframes arrow1 {
	100% {
		opacity: 0;
		left: 100%;
	}
}

@keyframes arrow2 {
	100% {
		opacity: 0;
		left: 50%;
	}
}
</style>

<style>
.rel {
	position: relative;
}
.scroll-x {
	overflow-x: auto;
}
.rel2 {
	position: absolute;
	z-index: 100;
	font-size: 12px;
}

.room-floor {
	position: relative;
	width: 100%;
	height: 100%;
	background-position: center;
	background-repeat: no-repeat;
	background-size: 100% 100%;
}

.tableName {
	white-space: nowrap;
	width: 50px;
	overflow: hidden;
	text-overflow: ellipsis;
}
</style>
